import { render, staticRenderFns } from "./BurgerMenuItem.vue?vue&type=template&id=c078b47a&scoped=true&"
import script from "./BurgerMenuItem.vue?vue&type=script&lang=js&"
export * from "./BurgerMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./BurgerMenuItem.vue?vue&type=style&index=0&id=c078b47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c078b47a",
  null
  
)

export default component.exports